import type { SxProps } from '@ori-ui/mui';
import { Box, CircularProgress } from '@ori-ui/mui';

const boxStyle: SxProps = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: 'inherit',
    justifyContent: 'center',
    textAlign: 'center',
};

export const Loading = () => (
    <Box sx={boxStyle}>
        <CircularProgress size={50} />
    </Box>
);
